import * as React from 'react';
import { Ref, useEffect, useRef } from 'react';
import { useLanguage } from './Language/useLanguage';

declare global {
    namespace React {
        namespace JSX {
            interface IntrinsicElements {
                'sgwt-help-center': IHelpCenter;
            }
        }
    }
}

interface IHelpCenterApi extends IHelpCenter {
    setLanguage: (language: string) => void;
    setKnowledgeUrls: (urls: string[]) => void;
}

interface IHelpCenter {
    ref?: Ref<IHelpCenter>;
    language?: string;
    'knowledge-urls'?: string[];
}

export const HelpCenter: React.FC = () => {
    const language = useLanguage().selectedLanguage.toLowerCase();

    const ref = useRef<IHelpCenterApi>(null);

    // Do not use constant for cdn url, it is not implemented on uat.
    useEffect(() => {
        if (ref.current?.setLanguage && ref.current?.setKnowledgeUrls) {
            ref.current.setLanguage(language);
            ref.current.setKnowledgeUrls([`https://shared.sgmarkets.com/info-help-center/sgm-legal/${language}.json`]);
        }
    }, [language]);

    return <sgwt-help-center
        ref={ref}
        language={language}
        knowledge-urls={[`https://shared.sgmarkets.com/info-help-center/sgm-legal/${language}.json`]}
    />;
};